import React from "react";
import { Route, Routes } from "react-router-dom";
import ListDeals from "../Components/Deals/listDeals";
import ViewDeal from "../Components/Deals/ViewDeal";
import DealForm from "../Components/Deals/DealForm";

const DealsRoutes = () => {
  return (
    <Routes>
      <Route path="/deals" element={<ListDeals></ListDeals>}></Route>
      <Route path="/deals/view/:id" element={<ViewDeal />}></Route>
      <Route path="/deals/add" element={<DealForm />} />
      <Route path="/deals/edit/:id" element={<DealForm />} />
    </Routes>
  );
};

export default DealsRoutes;
